import { http } from '@/lib/http';
import type { ListQuery, Page } from '@/types/common';
import type { PlatformUser, PlatformUserCreatePayload } from '@/types/platform';

const BASE = '/api/v1/platform/users';

export interface PlatformUserListQuery extends ListQuery {
  tenantId?: string;
  organizationId?: string;
  role?: string;
}

// H2 — plan-gated seat quota for the calling tenant.
export interface UserQuota {
  used: number;
  /** null = unlimited (Enterprise / Custom). */
  max: number | null;
  planSlug: string;
  planName: string;
  atLimit: boolean;
}

export const platformUsersService = {
  list: (query: PlatformUserListQuery = {}) =>
    http.get<Page<PlatformUser>>(BASE, { params: query }),
  get: (id: string) => http.get<PlatformUser>(`${BASE}/${id}`),
  create: (payload: PlatformUserCreatePayload) =>
    http.post<PlatformUser, PlatformUserCreatePayload>(BASE, payload),
  update: (id: string, payload: Partial<PlatformUserCreatePayload>) =>
    http.patch<PlatformUser, Partial<PlatformUserCreatePayload>>(`${BASE}/${id}`, payload),
  quota: () => http.get<UserQuota>(`${BASE}/quota`),
};
